import NoGroupsLayout from './NoGroupsLayout';

export default NoGroupsLayout;
